/**
 * Small presentational primitives shared by the Referral CRM (iter 170 split).
 *   • Kpi        — headline stat tile
 *   • MiniStat   — inline stat inside the drawer header
 *   • TextField  — labeled text input used by the new-facility modal and
 *                  the contacts form
 */
import React from 'react';

export function Kpi({ label, value, sub, icon: Icon, testId }) {
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4" data-testid={testId}>
      <div className="flex items-center gap-1.5 text-xs uppercase tracking-wide text-slate-500">
        {Icon && <Icon className="h-3.5 w-3.5" />} {label}
      </div>
      <div className="mt-2 text-2xl font-semibold tabular-nums text-slate-100">{value}</div>
      {sub && <div className="text-[10px] mt-0.5 text-slate-500">{sub}</div>}
    </div>
  );
}

export function MiniStat({ label, value, icon: Icon, tone }) {
  return (
    <div className="rounded-lg bg-slate-900/60 border border-slate-800 p-2">
      <div className="text-[10px] uppercase tracking-wide text-slate-500 flex items-center justify-center gap-1">
        {Icon && <Icon className="h-2.5 w-2.5" />} {label}
      </div>
      <div className={`text-lg font-semibold tabular-nums ${tone || 'text-slate-100'}`}>{value}</div>
    </div>
  );
}

export function TextField({ label, value, onChange, testId, autoFocus }) {
  return (
    <label className="block">
      <span className="text-[10px] font-medium uppercase tracking-wide text-slate-500">{label}</span>
      <input
        autoFocus={autoFocus}
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="mt-0.5 w-full bg-slate-900 border border-slate-800 rounded-md px-2.5 py-1.5 text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cn-primary/60"
        data-testid={testId}
      />
    </label>
  );
}
